import { render, staticRenderFns } from "./AddManager.vue?vue&type=template&id=628668be&scoped=true&"
import script from "./AddManager.vue?vue&type=script&lang=js&"
export * from "./AddManager.vue?vue&type=script&lang=js&"
import style0 from "./AddManager.vue?vue&type=style&index=0&id=628668be&lang=less&scoped=true&"
import style1 from "./AddManager.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628668be",
  null
  
)

export default component.exports